import { render, staticRenderFns } from "./ModalPlanAttribute.vue?vue&type=template&id=6b23ed78"
import script from "./ModalPlanAttribute.vue?vue&type=script&lang=js"
export * from "./ModalPlanAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports